import NcWelcomeback2025 from './NcWelcomeback2025.json'
import NcMitXfocePrime2025 from './nc_mit_xfoce_prime_2025.json'
import NcMitXfoceExisting2025 from './nc_mit_xfoce_existing_2025.json'
import Q22025CrmUsed from './Q22025CrmUsed.json'
import Q22025ProspectdldUsed from './Q22025ProspectdldUsed.json'
import NcToyotaHotlead2025 from './NcToyotaHotlead2025.json'
import DldInsight from './dld_insight.json'
import Q1CasaSpecial from './25Q1_CASA_Special.json'

// prettier-ignore
const campaign = [
  Q1CasaSpecial,
  Q22025CrmUsed,
  NcMitXfocePrime2025,
  NcMitXfoceExisting2025,
  Q22025ProspectdldUsed,
  NcToyotaHotlead2025,
  DldInsight,
  NcWelcomeback2025,
]

export default campaign
